var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{attrs:{"name":"header"}}),_c('v-main',{staticStyle:{"background-color":"#ebedf0"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }